import { Component, Input, OnInit } from '@angular/core';
import { IFormInput } from '@mwe/models';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-form-input-help-info',
  templateUrl: './form-input-help-info.component.html',
  imports: [TranslateDirective],
})
export class FormInputHelpInfoComponent implements OnInit {
  @Input() inputElem: IFormInput;

  constructor() {}

  ngOnInit(): void {}
}
